export default {
  username: {
    duplicated: 'This email already exists',
  },
};
